<img [src]="imagePath" [ngClass]="classes" alt="imageAlt" loading="lazy" />
